module.exports = __webpack_public_path__ + "media/images/logo-77a712cde7a81c0cb4661dbce9b8e039.jpg";